import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Order } from 'gung-standard';

@Component({
  selector: 'otto-olsen-claim-modal',
  templateUrl: './otto-olsen-claim-modal.component.html',
  styleUrl: './otto-olsen-claim-modal.component.scss',
  standalone: false
})
export class OttoOlsenClaimModalComponent {
  order: Order;

  constructor(
    private activeModal: NgbActiveModal,
    protected router: Router
  ) {}
  
  fullOrderClaim(){
    this.activeModal.dismiss();
    console.log(this.router);
    this.router.navigate(['/otto-olsen-create-full-order-claim/', this.order.id]);
  }
  partialOrderClaim() {
    this.activeModal.dismiss();
    console.log(this.router);
    this.router.navigate(['/otto-olsen-create-partial-order-claim/', this.order.id]);
  }

  cancel() {
    this.activeModal.dismiss();
  }
}

